/**
 * Pilot-gate access decision (pure, no React) — RND-36404.
 *
 * Statsig reports an evaluation `reason` alongside every gate value. A gate that
 * actually resolved server/cache-side ends in `:Recognized`. Anything else
 * (`:Unrecognized` = gate not created in the console yet, `Uninitialized`,
 * `NoValues`, an error, …) means we could NOT confirm the gate, so we fall back
 * to a single documented default.
 */

/**
 * What to do when the pilot gate can't be confirmed (network failure, or the
 * gate isn't created in the Statsig console yet).
 *
 * Fail-open (`true`) vs fail-closed (`false`) is a pending team decision
 * (Daniel / Dotan / Haim, asked in Slack); the value below is the current
 * provisional choice and is a one-line flip.
 *
 * DEPLOY SEQUENCING (fail-closed hazard): while this is `false`, a
 * `STATSIG_CLIENT_KEY` present in an environment WITHOUT the
 * `access_registration_pilot` gate created + targeted in the Statsig console
 * makes every eval resolve `…:Unrecognized` → fail-closed → 100% of
 * registrations blocked. Only inject the per-environment key AFTER the console
 * gate exists and its targeting is set.
 */
export const PILOT_GATE_DEFAULT_WHEN_UNKNOWN = false;

export type PilotGateEvaluation = {
  value: boolean;
  reason: string;
};

export const shouldAllowPilotAccess = ({ value, reason }: PilotGateEvaluation): boolean => {
  const confirmed = reason.endsWith(':Recognized');
  return confirmed ? value : PILOT_GATE_DEFAULT_WHEN_UNKNOWN;
};
